import axios from 'axios';

export default {
    orderPartsForSemifinishedProduct(productId, orderAmount) {
        return axios.post('/product/orderPartsForSemifinishedProduct/', {
            productId: productId,
            amount: orderAmount,
        });
    },
    overviewSemifinishedProducts(payload) {
        return axios.post('/product/overviewSemifinishedProducts/', payload);
    },
};
